import React from 'react'
import Header from '../Common/Header'
import Navigation from '../Common/Navigation'
import { useState } from 'react';
import {
    Button,
    Cascader,
    ConfigProvider,
    DatePicker,
    Form,
    Input,
    InputNumber,
    Radio,
    Select,
    Switch,
    TreeSelect,
} from 'antd';


function ApplicationForm() {
    const [componentSize, setComponentSize] = useState('default');
    const onFormLayoutChange = ({ size }) => {
        setComponentSize(size);
    };


    return (
        <div>
            <Header />

     <Form
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 14 }}
                layout="horizontal"
                initialValues={{ size: componentSize }}
                onValuesChange={onFormLayoutChange}
                size={componentSize}
                style={{ maxWidth: 600 }}
            >

                <Form.Item label="Input">
                    <Input />
                </Form.Item>
                <Form.Item label="Select">
                    <Select>
                        <Select.Option value="demo" type="primary">Demo</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item label="Cascader">
                    <Cascader
                        options={[
                            {
                                value: 'zhejiang',
                                label: 'Zhejiang',
                                children: [{ value: 'hangzhou', label: 'Hangzhou' }],
                            },
                        ]}
                    />
                </Form.Item>
                <Form.Item label="DatePicker">
                    <DatePicker />
                </Form.Item>
                <Form.Item label="InputNumber">
                    <InputNumber />
                </Form.Item>
                <Form.Item label="Switch" valuePropName="checked">
                    <Switch />
                </Form.Item>
                <Form.Item label="Button">
                    <Button type="primary">Button</Button>
                </Form.Item>
            </Form>


          

        </div>
    )
}

export default ApplicationForm
